import { DEFAULT_LOCATION } from 'shared/constants/defaultValues';
import { MOSCOW_AND_REGION_ID, SPB_AND_REGION_ID } from 'shared/constants/regions';
import { ResponseError } from 'shared/errors';
import {
  fetchCianApiSiteV1GetLocation,
  ICianApiSiteV1GetLocationRequest,
  TCianApiSiteV1GetLocationResponse,
} from 'shared/repositories/monolith-python/cian-api/site/v1/get-location';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TLocation } from 'shared/types/location';

export const fetchLocation = async (
  { httpApi, logger, custom: { subdomain } }: IApplicationContext,
  parameters: ICianApiSiteV1GetLocationRequest,
): Promise<TLocation> => {
  const { regionId } = parameters;

  if (regionId === MOSCOW_AND_REGION_ID) {
    return 'moscow_mo';
  }

  if (regionId === SPB_AND_REGION_ID) {
    return 'spb_lo';
  }

  try {
    const { response, statusCode }: TCianApiSiteV1GetLocationResponse = await fetchCianApiSiteV1GetLocation({
      httpApi,
      parameters,
      config: {
        subdomain,
      },
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchLocation',
        message: response.data.message || '',
        details: {
          error: JSON.stringify(response.data.errors),
        },
      });
    }

    return response.data;
  } catch (e) {
    logger.warning(
      {
        ...e,
        details: {
          ...e.details,
          microserviceName: 'monolith-python',
          pathApi: '/cian-api/site/v1/get-location/',
          parameters: JSON.stringify(parameters),
        },
      },
      {
        degradation: 'Запрос информации о гео по региону',
      },
    );

    return DEFAULT_LOCATION;
  }
};
